import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Sun, Moon } from 'lucide-react';
import '../styles/Projects.css';
import '../styles/Design.css';
import '../styles/HomePage.css';

// Import your project images
import fridgeFriendImg from '../assets/images/fridgefriend.jpg';
import billifyImg from '../assets/images/billify.jpg';
import companionImg from '../assets/images/companion.jpeg';
import eduscribeImg from '../assets/images/eduscribe.jpg';
import spleefImg from '../assets/images/spleef.jpg';
import visioncraftImg from '../assets/images/visioncraft.jpg';
import creatorImg from '../assets/images/creator.png';
import pitchPleaseImg from '../assets/images/pitchplease.jpeg';
import sqwitsImg from '../assets/images/sqwits.jpg';

const projectsData = [
  {
    id: 1,
    title: "CREATOR INTELLIGENCE",
    description: "agentic crm for creators",
    image: creatorImg,
    details:
      "crm that helps creators analyze audience engagement, detect churn, and generate marketing campaign & insights using autonomous agents.<br /><br />• implemented backend data pipelines with prisma and sqlite, supporting bulk ingestion and campaign attribution.<br />• integrated ai agents for audience segmentation and strategy recommendations, with scripted profile enrichment using puppeteer.<br /><br /> won rox best ai agent at hack the north 2025.",
    website: "https://github.com/ochen1/creator-intelligence/",
    tags: ["node.js", "javascript", "prisma", "puppetlabs"],
  },
  {
    id: 2,
    title: "PITCH PLEASE",
    description: "ai pitch judging platform",
    image: pitchPleaseImg,
    details: "built an ai-driven judging system with langchain-powered agents simulating sponsor judges (rbc, google, 1password).<br /><br />• scraped a16z & sponsor portfolios to generate dynamic investment rubrics based on real investor criteria.<br />• enabled multi-agent conversations for personalized, company-specific pitch feedback.<br />• integrated opencv & deepface for real-time analysis of speaking pace, emotions, and presentation style.<br /><br />won best ai project built with databricks oss (langchain) at uoft hacks.",
    website: "https://github.com/whyismynamerudy/pitch-please",
    tags: ["langchain", "opencv", "deepface", "python"],
  },
  {
    id: 3,
    title: "SQWITS GAME",
    description: "squid game inspired focus timer",
    image: sqwitsImg,
    details: "pomodoro timer that detects phone distractions and punishes users in squid game inspired ways with embarrassing emails, roast songs, & mini challenges.<br /><br />• leveraged databricks & mlflow to analyze productivity trends and predict study performance.<br />• integrated websockets & openai apis for real-time feedback and interactive tasks.<br /><br />won best use of databricks & 3rd place overall at shehacks, canada's largest female hackathon.",
    website: "https://github.com/AnneSun1/SqWiTs-game",
    tags: ["databricks", "mlflow", "websockets", "openai"],
  },
  {
    id: 4,
    title: "FRIDGEFRIEND",
    description: "transform leftovers into delicious meals",
    image: fridgeFriendImg,
    details: "developed a platform using python and streamlit for the front-end, with yolo for image recognition of fridge contents.<br /><br />• integrated a recipe dataset vectorized with scikit-learn for personalized recipe recommendations.<br />• implemented propelauth for user authentication and mongodb atlas to store user data.<br /><br />best ui/ux design at technova 2024.",
    website: "https://github.com/albertred/technova2024",
    tags: ["python", "streamlit", "yolo", "mongodb"],
  },
  {
    id: 5,
    title: "BILLIFY",
    description: "soap notes into billing codes",
    image: billifyImg,
    details: "developed a full-stack platform using mongodb, express.js, react, and node.js, integrating google cloud healthcare nlp for medical text analysis and google vision api for handwritten note transcription.<br /><br />• implemented web scraping with selenium and beautiful soup for up-to-date billing codes.<br />• containerized the application with docker and utilized postman for API testing and validation.<br /><br /> finalist at deltahacks x.",
    website: "https://github.com/fengzhang789/Billify",
    tags: ["mongodb", "express.js", "node.js", "google cloud"],
  },
  {
    id: 6,
    title: "COMPANION",
    description: "hologram ai friend for seniors",
    image: companionImg,
    details: "developed a user-friendly voice assistant by fine-tuning openai gpt-3.5 with kore for structured data extraction, and integrating elevenlabs for realistic audio responses.<br /><br />• built the backend with flask in python and frontend using next.js.<br />• used assemblyai for speech-to-text transcription and did ai for animated video generation.<br />• enabled real-time healthcare monitoring with google cloud.<br /><br />won the senior advisory award in the velocity agetech innovation challenge",
    website: "https://agetech-b9sj.vercel.app/",
    tags: ["python", "flask", "next.js", "google cloud"],
  },
  {
    id: 7,
    title: "EDUSCRIBE",
    description: "language learning & transcription",
    image: eduscribeImg,
    details: "created a full-stack platform using flask, python, html/css, and javascript to transcribe audio, translate text, and summarize transcripts for improved accessibility and comprehension. <br /><br /> won 3rd place overall and best case competition at the goldenhack.",
    website: "https://github.com/lucyqqi/goldenhacks",
    tags: ["flask", "python", "html/css", "javascript"],
  },
  {
    id: 8,
    title: "SPLEEF.AI",
    description: "ai-driven interview training",
    image: spleefImg,
    details: "developed an ai-powered assistant that simulates interviews, analyzes responses with whisper ai and gpt-3.5-turbo, and provides real-time feedback to enhance preparation.<br /><br />won most innovative hack and 2nd overall at ignition hacks, invited to brilliant catalyst incubator.",
    website: "https://github.com/iankorovinsky/ignition-hacks",
    tags: ["python", "whisper ai", "gpt-3.5-turbo"],
  },
  {
    id: 9,
    title: "VISIONCRAFT",
    description: "reimagining e-waste with deep learning",
    image: visioncraftImg,
    details: "built with next.js, tailwind css, and a flask-based backend deployed on google cloud app engine.<br /><br />• integrated yolov3 via roboflow for object detection from user-uploaded images.<br />• used openai apis (dalle, gpt-3.5-turbo) to generate diy tutorial content.<br />• generated downloadable pdfs with fpdf and pypdf2, hosted on ipfs for decentralized access.<br />• deployed the front-end on vercel with api calls.",
    website: "https://github.com/angeladev333/visioncraft-ai",
    tags: ["next.js", "flask", "google cloud"],
  }
];

const ProjectModal = ({ project, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2 className="modal-title">{project.title}</h2>
        <p className="project-description">{project.description}</p>
        
        {project.tags && (
          <div className="project-tags">
            {project.tags.map(tag => (
              <span key={tag} className="project-tag">
                {tag}
              </span>
            ))}
          </div>
        )}
        
        <img src={project.image} alt={project.title} className="modal-image" />
        <div 
          className="modal-details"
          dangerouslySetInnerHTML={{ __html: project.details }} 
        />
        <div className="modal-actions">
          {project.website && (
            <a 
              href={project.website}
              className="website-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              view project
              <ArrowUpRight className="arrow-icon" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

// Preload images for better caching
const preloadImage = (src) => {
  const img = new Image();
  img.src = src;
};

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isDark, setIsDark] = useState(() => {
    // On mobile, default to light mode
    const isMobile = window.innerWidth <= 640;
    if (isMobile) {
      return false;
    }
    // Read from localStorage on initial load for desktop
    const saved = localStorage.getItem('darkMode');
    return saved === 'true';
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Preload all project images on component mount
  useEffect(() => {
    projectsData.forEach(project => {
      preloadImage(project.image);
    });
  }, []);

  useEffect(() => {
    // Save to localStorage whenever dark mode changes
    localStorage.setItem('darkMode', isDark.toString());
    
    if (isDark) {
      document.body.style.backgroundColor = '#111827';
      document.documentElement.style.backgroundColor = '#111827';
    } else {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [isDark]);

  return (
    <div className={`container ${isDark ? 'dark' : ''}`}>
      <header className="header">
        <nav className="nav">
          <Link to="/" className="nav-link">home</Link>
          <Link to="/experience" className="nav-link">experience</Link>
          <Link to="/projects" className="nav-link">projects</Link>
          <Link to="/design" className="nav-link">design</Link>
          <button 
            onClick={() => setIsDark(!isDark)}
            className="theme-toggle"
            aria-label="Toggle theme"
          >
            {isDark ? <Sun size={20} /> : <Moon size={20} />}
          </button>
        </nav>
      </header>

      <main className="projects-content">
      <br></br>

        <h1 className="page-title">PROJECTS</h1>
        <p className="page-description">
        working on problems involving messy data, evolving requirements, and real-world constraints
        </p>
       

<p className="page-description">
i build systems that scale from prototype to production without losing usability
        </p>
        <br></br>
        <br></br>

        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <div 
              key={project.id}
              className="project-card"
              onClick={() => setSelectedProject(project)}
            >
              <img 
                src={project.image} 
                alt={project.title} 
                className="project-image"
                loading={index < 3 ? "eager" : "lazy"}
                fetchPriority={index < 3 ? "high" : "auto"}
                decoding="async"
              />
              <div className="project-info">
                <h2 className="project-title">{project.title}</h2>
                <p className="project-description">{project.description}</p>
                {project.tags && (
                  <div className="project-tags">
                    {project.tags.map(tag => (
                      <span key={tag} className="project-tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>

      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}

      <footer className="footer">
        <p>made with <span className="highlight">♥</span> in <span className="highlight">toronto</span></p>
      </footer>
      <br></br>
    </div>
    
  );
};

export default Projects;